/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Old addresses that still arrive, first in main.tsx's route table, outside
 * App and without AddLangToPath: they must work whatever language the page
 * was opened in, and a static first segment outranks the dynamic product and
 * article patterns, so nothing else changes.
 *
 * - N-3: /en and /en/… land on the same page without the prefix. "/en" is
 *   listed on its own as well as "/en/*" so the bare address does not depend
 *   on how the router treats an empty splat.
 * - /forum and /forum/, the old forum index: on to the forum.
 * - /survey.aspx and /mypcinfo.aspx, which installed products still open: the
 *   uninstall survey (with PID, ver and BuildVer in the address) and My PC Info
 *   from the help files. nginx.conf answers both with a 301; these routes cover
 *   a host that serves the app without it. React Router matches without regard
 *   to case, as the old site did, so /MyPCInfo.aspx is covered too. The old
 *   download page and the old What's New address are search-engine addresses,
 *   not ones an installed product opens: they are left to nginx.conf alone, so
 *   the list of old download IDs lives in one place.
 *
 * Kept apart from the components so each component file exports only a
 * component.
 */

import type { RouteObject } from "react-router-dom";
import DropEnglishPrefix from "@/components/common/DropEnglishPrefix";
import LegacyRedirect from "@/components/common/LegacyRedirect";
import OldForumIndex from "@/components/common/OldForumIndex";

export const legacyAddressRoutes: RouteObject[] = [
  { path: "/en", element: <DropEnglishPrefix /> },
  { path: "/en/*", element: <DropEnglishPrefix /> },
  // The old forum index (/forum and /forum/), which installed applications
  // still open: on to the forum. Exact, so nothing under /forum/ is caught.
  { path: "/forum", element: <OldForumIndex /> },
  // The uninstall survey: the query (PID, ver, BuildVer) goes along, so the
  // feedback says which product was uninstalled.
  {
    path: "/survey.aspx",
    element: <LegacyRedirect to="/uninstall-feedback" keepQuery />,
  },
  // My PC Info, from WebCam Monitor's and Security Monitor Pro's help files.
  { path: "/mypcinfo.aspx", element: <LegacyRedirect to="/mypcinfo" /> },
];
